import { render, staticRenderFns } from "./ed-subject-builder-rules.component.vue?vue&type=template&id=2a2f07be&scoped=true&"
import script from "./ed-subject-builder-rules.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-builder-rules.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-builder-rules.component.scss?vue&type=style&index=0&id=2a2f07be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f07be",
  null
  
)

export default component.exports